import React, {useEffect} from 'react';
import {FormattedMessage} from 'react-intl';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {LoginByPhoneContextProvider} from '../../components/LoginByPhoneContext';
import PageHeader from '../../../../common/components/ui/PageHeader';
import SectionPanel from '../../../../common/components/ui/SectionPanel';
import LoginByPhoneMessage from '../../components/LoginByPhoneMessage';
import FieldPhone from '../../components/FieldPhone';
import FieldCode from '../../components/FieldCode';
import ButtonLoginByPhone from '../../components/ButtonLoginByPhone';
import ButtonLink from '../../components/ButtonLink';
import FooterLogo from '../../../../common/components/ui/FooterLogo';
import {pathnames as P} from '../../../../common/enums/pathnames';
import styles from './LoginByPhone.module.scss';

const LoginByPhone = () => {
  const {setPageTitle} = useGlobalContext();

  useEffect(() => {
    setPageTitle((
      <PageHeader
        id={'login-by-phone-page-header'}
        defaultMessage={'Login via SMS'}
        showLogo={true}
        className={styles.customHeader}
      />
    ));
  }, []);

  return (
    <LoginByPhoneContextProvider>
      <SectionPanel className={styles.loginByPhoneContainer}>
        <LoginByPhoneMessage/>
        <FieldPhone/>
        <FieldCode/>
        <ButtonLoginByPhone/>
        <ButtonLink
          link={P.LOGIN}
          label={
            <FormattedMessage
              id={'button-back-to-login'}
              defaultMessage={'Back to Login'}
            />
          }
        />
      </SectionPanel>
      <FooterLogo/>
    </LoginByPhoneContextProvider>
  );
};

export default LoginByPhone;
